var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.0003,
    cy: 6.66634,
    r: 3.33333,
    fill: "#278B9F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.38352 14.7243C4.91429 12.203 7.42376 10.833 10.0003 10.833C12.5769 10.833 15.0864 12.203 15.6171 14.7243C15.682 15.0322 15.7355 15.3483 15.7731 15.6686C15.8375 16.2171 15.3859 16.6663 14.8337 16.6663H5.16699C4.61471 16.6663 4.16315 16.2171 4.22757 15.6686C4.26518 15.3483 4.31869 15.0322 4.38352 14.7243Z",
    fill: "#278B9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSmall);
export default __webpack_public_path__ + "static/media/userSmall.892ff3cfb95c2e7fb887de7ed1bd531f.svg";
export { ForwardRef as ReactComponent };